import { Spin } from 'antd'
import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div<{
  $opacity?: number
  $background: string
  $notAllowed?: boolean
}>`
  .ant-spin-blur {
    opacity: ${({ $opacity }) => $opacity};
    &::after {
      opacity: 1;
      background: ${({ $background }) => $background};
    }
  }
  ${({ $notAllowed }) => {
    if ($notAllowed) {
      return `
        cursor: not-allowed
      `
    }
  }}
`

interface IProps {
  disabled?: boolean
  children?: ReactNode
  opacity?: number
  background?: string
  notAllowed?: boolean
}

const Disabled = (props: IProps) => {
  const {
    disabled,
    children,
    opacity = 0.8,
    notAllowed,
    background = 'transparent'
  } = props

  return (
    <StyledContainer
      $opacity={opacity}
      $background={background}
      $notAllowed={notAllowed && disabled}>
      <Spin spinning={disabled} indicator={<></>}>
        {children}
      </Spin>
    </StyledContainer>
  )
}

export default Disabled
